var getLength = require('./getLength'),
    isLength = require('./isLength');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

module.exports = isArrayLike;



/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-bootstrap/~/lodash-compat/internal/isArrayLike.js
 ** module id = 343
 ** module chunks = 0
 **/